import { styled, Typography } from '@mui/material';

export const FieldDescriptionStyled = styled(Typography)(({ theme, inline }) => ({
  '& a': {
    color: 'inherit',
  },
  display: inline ? 'inline' : 'blocl',
}));
